import { motion, MotionValue, useTransform } from "framer-motion";
import { memo, useMemo, useState } from "react";
import { BrushEventData } from "./Brush.types";

const BrushEvent = memo(function BrushEvent({
  event,
  startTimeMotionValue,
  endTimeMotionValue,
  width = 0,
  renderEvent = (event: BrushEventData, width: number) => null,
}: {
  event: BrushEventData;
  startTimeMotionValue: MotionValue<number>;
  endTimeMotionValue: MotionValue<number>;
  width?: number;
  renderEvent?: (event: BrushEventData, width: number) => React.ReactNode;
}) {
  // Use transform to calculate position based on time motion value
  const leftPosition = useTransform(() => {
    const startTime = startTimeMotionValue.get();
    const endTime = endTimeMotionValue.get();
    const timeRange = endTime - startTime;

    if (timeRange === 0) return "0%";

    let position = (event.timestamp - startTime) / timeRange;
    position = Math.max(-0.5, Math.min(1.5, position));

    // if (position <= 0.0 || position >= 1.0) {
    //   if (isVisible) {
    //     setIsVisible(false);
    //   }
    // } else {
    //   if (!isVisible) {
    //     setIsVisible(true);
    //   }
    // }

    return `${position * 100}%`;
  });

  const children = useMemo(() => {
    return renderEvent(event, width);
  }, [event, width, renderEvent]);

  // if (!isVisible) return null;

  return (
    <motion.div
      style={{
        position: "absolute",
        left: leftPosition,
        bottom: 0,
        height: "100%",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        zIndex: 5,
        pointerEvents: "none",
      }}
    >
      {children}
    </motion.div>
  );
});

export { BrushEvent };
